import colors from '@packages/core/styles/colors';
import { Typography } from '@packages/ui/shared';
import { TableCell } from '@web/components/table';
import { getDisplayValue } from '@web/utils';
import { FC } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { StyleProp, TextStyle } from 'react-native';

interface JobFieldCellProps {
    rowId: string;
    rawValue: any;
    tooltipPrefix: string;
    className: string;
    typographyStyles: StyleProp<TextStyle>;
    formatValue?: (val: any) => string;
    getDisplay?: (val: any) => string;
}

const useDmsListStyles = createUseStyles({
    tooltip: {
        marginTop: 5,
        '& .tooltip-inner': {
            backgroundColor: colors.graySeven,
            borderRadius: 4,
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '20px',
            maxWidth: 272,
            padding: '3px 8px',
            textAlign: 'left',
            width: 'auto',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
        },
    },
});

export const JobFieldCell: FC<JobFieldCellProps> = ({
    rowId,
    rawValue,
    tooltipPrefix,
    className,
    typographyStyles,
    formatValue,
    getDisplay = getDisplayValue,
}) => {
    const classes = useDmsListStyles();
    const displayVal = formatValue ? formatValue(rawValue) : getDisplay(rawValue);
    return (
        <TableCell className={className}>
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip className={classes.tooltip} id={`${tooltipPrefix}-tooltip-${rowId}`}>
                        {displayVal}
                    </Tooltip>
                }
            >
                <div style={{ width: '100%' }}>
                    <Typography numberOfLines={1} style={typographyStyles}>
                        {displayVal}
                    </Typography>
                </div>
            </OverlayTrigger>
        </TableCell>
    );
};
